import React, { useContext, useMemo, useState } from "react";
import "./CardCompanyResult.css";

import { Button, InfoTooltip, TimedTooltip } from "../../atoms";
import defImage from "../../../img/logo_default.jpg";
import logo from "../../../../src/assets/logoWhite.svg";
import { AppGeneralContext } from "../../../shared/GeneralContext/GeneralContext";
import { OptionTypes } from "../../types/types";
import cardImage from "../../../../src/assets/InnovationMatchPress.jpg";
import useMediaQuery from "../../../hook/useMediaQuery";
import { MediaMobile } from "../../../api/const/MediaQuery";
import clsx from "clsx";

interface cardPropType {
  id: string;
  title?: string;
  category?: string;
  description?: string;
  tags?: OptionTypes[];
  backgroundImage?: string;
  squareImage?: string;
  matchCallback: (id: string) => void;
  profileCallback: () => void;
  canMatch?: boolean;
  unmatchableReason?: string;
}

export const CardCompanyResult = ({
  unmatchableReason,
  canMatch,
  profileCallback,
  matchCallback,
  backgroundImage,
  squareImage,
  title,
  description,
  tags,
  category,
  id,
}: cardPropType) => {
  const { baseUri } = useContext(AppGeneralContext);

  const mobile = useMediaQuery(MediaMobile);
  const startUptags = useMemo(() => tags, [tags]);

  const descriptionHandler = (description: string | undefined) => {
    if (!description) {
      return;
    }

    if (description.length < 90) {
      return description;
    }

    if (
      description.length >= 90 &&
      description?.substring(0, 90).endsWith(" ")
    ) {
      return description?.substring(0, 89) + "...";
    }

    if (
      description.length >= 90 &&
      !description?.substring(0, 90).endsWith(" ")
    ) {
      return description?.substring(0, 90) + "...";
    }

    return;
  };

  return (
    <div
      className={clsx(
        "d-flex  justify-content-end  mb-5   position-relative",
        { "w-50 pe-3": !mobile },
        { "w-100 pe-2 ps-2": mobile }
      )}
    >
      <div className=" d-flex flex-column  card-cont">
        <div className="card-absolute__box">
          <img
            className="logo-s"
            onError={(event) => {
              event.currentTarget.src = defImage;
              event.currentTarget.onerror = null;
            }}
            src={squareImage ? `${baseUri}${squareImage}` : defImage}
            alt="profile-Image"
          />
        </div>

        <img
          className="img-cover"
          onError={(event) => {
            event.currentTarget.src = cardImage;
            event.currentTarget.onerror = null;
          }}
          src={backgroundImage ? `${baseUri}${backgroundImage}` : cardImage}
          alt="InnovationMatch"
        />

        <div className="flex-grow-1 overflow-hidden ps-3 pe-3 pt-3 d-flex flex-column">
          <h4 className="startUp__name m-0 p-0">{title}</h4>

          <div className="startUp__category d-flex flex-column mb-2">
            {category}
          </div>
          <p className="m-0 p-0">{descriptionHandler(description)}</p>

          <div className=" d-flex card-tag-container pt-1 mt-3 ">
            <ul
              className="d-flex flex-wrap w-100 "
              style={{ listStyleType: "none" }}
            >
              {startUptags?.map((tag,i) => {
                return (
                  <li key={tag?.id??tag.label + id+ i} className="tag ">
                    {tag.label}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-around p-2">
          <Button
            onClick={profileCallback}
            className="card-button__profile"
            removePadding
            uppercase
            background="var(--white)"
            text="show profile"
          />

          {unmatchableReason ? (
            <TimedTooltip
              text={unmatchableReason}
              childeren={
                <Button
                  disabled={!canMatch}
                  onClick={() => matchCallback(id)}
                  borderColor="transparent"
                  className="card-button"
                  removePadding
                  uppercase
                  background="var(--primary)"
                  icon={logo}
                  primary
                  color="var(--white)"
                  text="match"
                  removeRotate
                />
              }
            />
          ) : (
            <Button
              disabled={!canMatch}
              onClick={() => matchCallback(id)}
              borderColor="transparent"
              className="card-button"
              removePadding
              uppercase
              background="var(--primary)"
              icon={logo}
              primary
              color="var(--white)"
              text="match"
              removeRotate
            />
          )}
        </div>
      </div>
    </div>
  );
};
